import React from "react";
import { VbzLoadingLogo } from "@smiles/voebiz-ui-kit";
import { ModalBody } from "reactstrap";

const ModalBodyLoader = () => (
  <ModalBody className="vbz-modal-loading">
    <div className="vbz-modal-loading">
      <div className="LoadingModal_wrapper_loader">
        <VbzLoadingLogo id="loader" />
      </div>
      <span className="LoadingModal_wrapper_text-loading">Um momento</span>
    </div>
  </ModalBody>
);

export default ModalBodyLoader;
